import { Component, Input } from '@angular/core';
import { AppService } from './services/app.service';
import { MatSidenav } from '@angular/material/sidenav';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  idUnico;

  name = '';
  email = '';

  @Input() drawer: MatSidenav | undefined;

  isChecked = false;
  isAuthenticated = false;

  constructor(private appService : AppService, 
              public oidcSecurityService: OidcSecurityService ) {

    this.idUnico = appService.idUnico;
  }

  
  ngOnInit() {

    

    // landa@gmail.com
    // FF&w:'X9YGvyg}M

    // https://nice-hill-002425310.azurestaticapps.net/docs/intro
    // https://www.npmjs.com/package/angular-auth-oidc-client 

    // https://github.com/damienbod/angular-auth-oidc-client
    // https://github.com/damienbod/angular-auth-oidc-client/tree/version-13

    // https://github.com/manfredsteyer/angular-oauth2-oidc

    // ver a data del usuario que no llega
    // al cambiar las vistas al area, ahora al hacer login no redirige automaticamente , se queda en el Home del servidor

    console.log('>> AppComponent loaded > check auth data');

    // clear sessionStorage
    //window.addEventListener('beforeunload', () => sessionStorage.clear());

    this.oidcSecurityService
          .checkAuth()
          .subscribe(({ isAuthenticated, userData, accessToken, idToken }) => {

            console.log('app authenticated response', isAuthenticated);
            console.log('app userData', userData);

            // console.log(`Current access token is '${accessToken}'`);

            this.isChecked = true;
            this.isAuthenticated = isAuthenticated;

            if(isAuthenticated){
              
              this.appService.idUnico = userData.singlecustomer;
              this.appService.countryCode = userData.countrycode;

              console.log('updated app service', this.appService.countryCode);
            } else {
              this.login();
            }

      });
      

  }


  login() {
    console.log('start login');
    this.isChecked = false;
    this.oidcSecurityService.authorize();
  }

  refreshSession() {
    console.log('start refreshSession');
    this.oidcSecurityService.authorize();
  }

  logout() {

    this.appService.deleteClienteAppData();
    this.appService.deleteClienteUnicoData();
    console.log('start logoff');
    this.oidcSecurityService.logoff();
  }
  
  // **********************************

  close() {
    this.drawer?.close();
  }

  onOpen(){

    if(this.appService.idUnico) {
      var data = this.appService.getClienteAppDataSession(this.appService.idUnico);

      if(data && data.nombreCompletoPrincipal ) 
        this.name = data.nombreCompletoPrincipal;
      
      if(data && data.emailPrincipal ) 
        this.email = data.emailPrincipal;
    }

  }


 }




